import { useEffect, useState } from "react";
import type {
	Control,
	FieldValues,
	Path,
	PathValue,
	UseFormSetValue,
	UseFormTrigger,
	UseFormWatch,
} from "react-hook-form";

import ComboBox from "~/components/formElements/ComboBox";
import FormInputError from "~/components/formElements/FormInputError";
import type { FormInputOption } from "~/types/form.ts";

type Props<T extends FieldValues> = {
	control: Control<T>;
	errorMessage?: string;
	invoiceRecipientSelectOptions: FormInputOption[];
	isSubmitted?: boolean;
	clientContactPersonSelectOptions: FormInputOption[];
	setValue: UseFormSetValue<T>;
	trigger: UseFormTrigger<T>;
	watch: UseFormWatch<T>;
};

interface InvoiceRecipientFormSectionFormData {
	invoiceRecipientId: string | null;
	clientContactPersonId: string | null;
}

const InvoiceRecipientFormSection = <T extends InvoiceRecipientFormSectionFormData>({
	control,
	errorMessage,
	invoiceRecipientSelectOptions,
	isSubmitted,
	clientContactPersonSelectOptions,
	setValue,
	trigger,
	watch,
}: Props<T>) => {
	const invoiceRecipientId = watch("invoiceRecipientId" as Path<T>);
	const clientContactPersonId = watch("clientContactPersonId" as Path<T>);
	const [isInitialRender, setIsInitialRender] = useState(true);

	useEffect(() => {
		if (!isInitialRender && invoiceRecipientId) {
			setValue("clientContactPersonId" as Path<T>, null as PathValue<T, any>);
			if(isSubmitted === undefined || isSubmitted){
				trigger();
			}
		}
	}, [invoiceRecipientId, isInitialRender, isSubmitted, setValue, trigger]);

	useEffect(() => {
		if (!isInitialRender && clientContactPersonId) {
			setValue("invoiceRecipientId" as Path<T>, null as PathValue<T, any>);
			if(isSubmitted === undefined || isSubmitted){
				trigger();
			}
		}
	}, [clientContactPersonId, isInitialRender, isSubmitted, setValue, trigger]);

	useEffect(() => {
		setIsInitialRender(false);
	}, []);

	return (

		<div className="grid grid-cols-6 gap-x-6 gap-y-2">
			<div className="col-span-6">
				<ComboBox
					allowNew={false}
					control={control}
					label="Zentraler Rechnungsempfänger"
					name="invoiceRecipientId"
					optionsData={invoiceRecipientSelectOptions}
				/>
			</div>
			<div className="col-span-6">
				<ComboBox
					allowNew={false}
					control={control}
					label="Kontakt"
					name="clientContactPersonId"
					optionsData={clientContactPersonSelectOptions}
				/>
			</div>
			<div className={"col-span-6"}>{errorMessage && <FormInputError>{errorMessage}</FormInputError>}</div>
		</div>

	);
};

export default InvoiceRecipientFormSection;
